/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createPortal } from 'react-dom'
import React, { useState, useEffect, useCallback, ReactNode } from 'react'
import { get } from 'lodash'
import { Flex, Avatar } from '@ui'
import { IFloorMapSpace, IFullEmployee, IFloorMapPin, ISpace } from '@api/types'
import {
  isShared,
  isPrimary,
  isSecondary,
  isNeighborhood,
  isMeetingRoom,
  isUnallocatable,
} from '@utils'
import css from './adminFloorPlan.module.scss'
import SpaceDetailCard from './Cards/SpaceDetailCard'
import { Size } from '@ui/Avatar'

interface FloorMapTooltipProps {
  canvasMap: any
}

export default function FloorMapTooltip({ canvasMap }: FloorMapTooltipProps) {
  const LEFT_OFFSET = 80
  const TOP_OFFSET = 180
  const [tooltipData, setTooltipData] = useState<unknown>(null)
  const handleHover = useCallback(
    (data: any) => {
      if (data) {
        setTooltipData(data)
      } else if (tooltipData) {
        setTooltipData(null)
      }
    },
    [tooltipData]
  )

  useEffect(() => {
    canvasMap.subscribe('hover', handleHover)

    return () => {
      canvasMap.unsubscribe('hover', handleHover)
    }
  }, [canvasMap, handleHover])

  if (!tooltipData) return null

  const mapObject = get(tooltipData, 'mapObject', {}) as IFloorMapSpace | IFloorMapPin
  // let smallText = get(mapObject, 'code', '')
  const largeText = (
    <SpaceDetailCard
      space={mapObject as ISpace}
      showAvatar
      showEmployees
      avatarProps={{ size: Size.XS, style: { color: '#1F252C80', backgroundColor: '#CCCCCC' } }}
    />
  )

  // Hanele space tooltip
  // if ('spaceType' in mapObject) {
  //   const dName = get(mapObject, 'spaceAssignment.department.name')
  //   const tName = get(mapObject, 'spaceAssignment.team.name')
  //   const deptTeam = `${dName || ''}${tName ? ' | ' + tName : ''}`

  //   if (isMeetingRoom(mapObject.spaceType) || isUnallocatable(mapObject.spaceType)) {
  //     largeText = mapObject.name
  //   } else if (isShared(mapObject.usageType)) {
  //     const sharedEmployees: IFullEmployee[] =
  //       get(mapObject, 'spaceAssignment.sharedEmployees') || []

  //     largeText = sharedEmployees.length ? (
  //       <Flex>
  //         {sharedEmployees.map((emp) => (
  //           <div key={emp.id} style={{ margin: 2 }}>
  //             <Avatar size={Avatar.Size.XXS} name={emp.name} assets={emp.assets} />
  //           </div>
  //         ))}
  //       </Flex>
  //     ) : (
  //       deptTeam
  //     )
  //   } else if (isNeighborhood(mapObject.usageType)) {
  //     largeText = get(mapObject, 'spaceAssignment.neighborhood.name') || deptTeam
  //   } else if (isPrimary(mapObject.usageType) || isSecondary(mapObject.usageType)) {
  //     const emplName = get(mapObject, 'spaceAssignment.employee.name')
  //     const emplAssets = get(mapObject, 'spaceAssignment.employee.assets', [])
  //     largeText = (
  //       // emplAssets && emplAssets.length ? (
  //       <Flex align="center">
  //         <Avatar name={emplName} assets={emplAssets} size={Avatar.Size.XXS} />
  //         <span style={{ paddingLeft: 6 }}>{emplName || deptTeam}</span>
  //       </Flex>
  //     )
  //     // ) : (
  //     //   emplName || deptTeam
  //     // )
  //   }
  // } else if ('globalMapObject' in mapObject) {
  //   // Handle pins
  //   smallText = get(mapObject, 'globalMapObject.name')
  //   largeText = get(mapObject, 'map.name')
  // }

  return createPortal(
    <div
      className={css.tooltip_wrapper}
      style={{
        // @ts-ignore
        top: get(tooltipData, 'mouse[1]') - 10 + TOP_OFFSET || -1000,
        // @ts-ignore
        left: get(tooltipData, 'mouse[0]') + 5 + LEFT_OFFSET || -1000,
      }}
    >
      {
        (tooltipData && (
          <>
            {/* {smallText} */}
            {largeText && <div className={css.large}>{largeText}</div>}
          </>
        )) as ReactNode
      }
    </div>,
    document.body
  )
}
